export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`, `54-56`],
  [`Грудь`, `46`, `50`, `52`, `55`, `58`, `61`],
  [`Длина`, `68`, `70`, `72`, `74`, `76`, `78`]
];
